var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocalPostOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1760_313",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.892578,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1760_313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.39266 18.3332C3.15655 18.3332 2.95863 18.2533 2.79891 18.0936C2.63919 17.9339 2.55933 17.7359 2.55933 17.4998V10.8332C2.55933 10.5971 2.63919 10.3991 2.79891 10.2394C2.95863 10.0797 3.15655 9.99984 3.39266 9.99984H5.89266V6.6665C5.89266 5.27762 6.37877 4.09706 7.35099 3.12484C8.32322 2.15261 9.50377 1.6665 10.8927 1.6665H14.226C15.6149 1.6665 16.7954 2.15261 17.7677 3.12484C18.7399 4.09706 19.226 5.27762 19.226 6.6665V17.4998C19.226 17.7359 19.1461 17.9339 18.9864 18.0936C18.8267 18.2533 18.6288 18.3332 18.3927 18.3332C18.1565 18.3332 17.9586 18.2533 17.7989 18.0936C17.6392 17.9339 17.5593 17.7359 17.5593 17.4998V15.8332H14.226V17.4998C14.226 17.7359 14.1461 17.9339 13.9864 18.0936C13.8267 18.2533 13.6288 18.3332 13.3927 18.3332H3.39266ZM8.39266 14.0415L5.16349 12.2082C4.95516 12.0832 4.74683 12.0832 4.53849 12.2082C4.33016 12.3332 4.22599 12.5137 4.22599 12.7498C4.22599 12.8609 4.25377 12.9686 4.30933 13.0728C4.36488 13.1769 4.44127 13.2568 4.53849 13.3123L7.97599 15.2707C8.10099 15.3401 8.23988 15.3748 8.39266 15.3748C8.54544 15.3748 8.68433 15.3401 8.80933 15.2707L12.2468 13.3123C12.344 13.2568 12.4204 13.1769 12.476 13.0728C12.5315 12.9686 12.5593 12.8609 12.5593 12.7498C12.5593 12.5137 12.4552 12.3332 12.2468 12.2082C12.0385 12.0832 11.8302 12.0832 11.6218 12.2082L8.39266 14.0415ZM14.226 14.1665H17.5593V6.6665C17.5593 5.74984 17.2329 4.96512 16.5802 4.31234C15.9274 3.65956 15.1427 3.33317 14.226 3.33317H10.8927C9.97599 3.33317 9.19127 3.65956 8.53849 4.31234C7.88572 4.96512 7.55933 5.74984 7.55933 6.6665V9.99984H13.3927C13.6288 9.99984 13.8267 10.0797 13.9864 10.2394C14.1461 10.3991 14.226 10.5971 14.226 10.8332V14.1665ZM10.0593 8.33317C9.82322 8.33317 9.6253 8.25331 9.46558 8.09359C9.30585 7.93387 9.22599 7.73595 9.22599 7.49984C9.22599 7.26373 9.30585 7.06581 9.46558 6.90609C9.6253 6.74637 9.82322 6.6665 10.0593 6.6665H15.0593C15.2954 6.6665 15.4934 6.74637 15.6531 6.90609C15.8128 7.06581 15.8927 7.26373 15.8927 7.49984C15.8927 7.73595 15.8128 7.93387 15.6531 8.09359C15.4934 8.25331 15.2954 8.33317 15.0593 8.33317H10.0593Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocalPostOffice);
export default __webpack_public_path__ + "static/media/icon_local_post_office.8eefab688027cf6ca571295766171707.svg";
export { ForwardRef as ReactComponent };